import { EllipsisTooltip } from '@src/components/common';
import { Button, Layout, Menu } from 'antd';
import { Content } from 'antd/es/layout/layout';
import Sider from 'antd/es/layout/Sider';
import styled from 'styled-components';

export const FooterWrapper = styled.div`
  text-align: center;
  font-size: 1em;
  font-weight: 600;
  margin-top: 8px;
`;

export const StyledLayout = styled(Layout)`
  display: flex;
  flex-direction: row;
  height: 78vh;
  min-height: 0;
`;

export const TableWrapper = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden auto;
  background: #fff;
  position: relative;
  height: calc(78vh - 20px); /* Match parent height minus some padding */
`;

export const FilterContainer = styled.div`
  padding: 16px;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0;
`;

export const LoadMoreContainer = styled.div`
  text-align: center;
  font-size: 1em;
  font-weight: 600;
  margin-top: 8px;

  /* display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  border-top: 1px solid #f0f0f0;
  position: sticky;
  bottom: 0;
  background: #fff;
  z-index: 2; */
`;

export const LoadMoreButton = styled(Button)`
  min-width: 120px;
`;

// Table Empty State Components
export const StyledTableEmpty = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #8c8c8c;
  text-align: center;
`;

export const StyledTableEmptyTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #262626;
`;

export const StyledTableEmptySubtext = styled.div`
  font-size: 14px;
  color: #8c8c8c;
`;

export const AlertsCountBadge = styled.div`
  padding: 8px 16px;
  background: #f0f8ff;
  border-bottom: 1px solid #e6f7ff;
  color: #1890ff;
  font-size: 12px;
  text-align: center;
`;

export const FloatingApplyButton = styled(Button)`
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1000;
  background: #1890ff;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  height: auto;
  font-weight: 500;
  box-shadow: 0 4px 12px rgb(24 144 255 / 30%);
  transition: all 0.2s ease;

  &:hover {
    background: #40a9ff;
    color: white;
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgb(24 144 255 / 40%);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const TriggerButton = styled(Button)<{ collapsed?: boolean }>`
  width: 26px;
  height: 26px;
  z-index: 1001; /* Even higher than CollapseWrapper */
  padding: 0;
  position: absolute;
  background-color: #fff;
  border-radius: 50%;
  right: ${(props) => (props.collapsed ? '-26px' : '-14px')};
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  top: 25px;

  /* Hover styles with higher specificity */
  &:hover,
  &:hover:not(:disabled) {
    border-color: #096dd9 !important;
    background-color: #096dd9 !important;
    color: white !important;
    box-shadow: 0 2px 8px rgb(0 0 0 / 15%) !important;
  }
`;

export const StyledSider = styled(Sider)`
  background-color: #fafafa;
  transition: all 0.3s ease;

  .ant-layout-sider-children {
    background: #fafafa;
    padding-top: 15px;
  }
`;

export const StyledContent = styled(Content)<{ collapsed: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

export const CollapseWrapper = styled.div`
  position: absolute;
  inset: 0 100%;
  z-index: 1000; /* Very high to ensure it's above everything */
`;

export const Wrapper = styled.div`
  .ant-table-container {
    font-size: 14px;

    td {
      vertical-align: top !important;
    }
  }
`;

export const StyledMenu = styled(Menu)`
  background: #fafafa;
  max-height: 100%;
  overflow: scroll;
  scrollbar-width: thin;
  scrollbar-gutter: stable;

  .ant-menu-item-disabled.ant-menu-item-selected {
    background-color: #1890ff !important; /* Active background color */
    color: white !important; /* Text color when active */
  }

  .ant-menu-submenu .ant-menu-item-group-title {
    padding-inline-start: 16px !important;
  }
`;

export const StyledEllipsisTooltip = styled(EllipsisTooltip)`
  font-weight: 500;
  width: 90%;
  align-self: center;
`;

export const StyledChildren = styled.div<{ disabled: boolean }>`
  display: flex;
  justify-content: space-between;
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
`;

export const StyledLabel = styled.span`
  color: #4a4a4a;
`;

export const StyledNoAlert = styled.div`
  padding: 20px 20px 20px 15px;
  text-align: center;
  max-width: inherit;
`;

export const StyledStatusText = styled.div`
  font-size: 16px;
  font-weight: 450;
`;

export const StyledSubText = styled.p`
  font-size: 14px;
  color: #333;
  font-style: italic;
`;

export const Navig = styled.div<{ collapsed?: boolean }>`
  width: ${(props) => (props.collapsed ? '16px' : '3px')};
  position: absolute;
  background: #f5f5f5;
  inset-block: 0;
  inset-inline-start: -1px;
  pointer-events: none;
`;

export const SeverityLabel = styled.span<{ color }>`
  color: ${(props) => props.color};
`;
